import { render, staticRenderFns } from "./configForm.vue?vue&type=template&id=3455cac4&"
import script from "./configForm.vue?vue&type=script&lang=js&"
export * from "./configForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports